/*eslint no-unused-vars: "off"*/

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Axios from "axios";

import { appConfig } from "./config.js";
Vue.use(appConfig);
window.appConfig = appConfig;

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import './styles/style.css';
// import "vue-themify-icons/themify-icons/themify-icons.css";

import BootstrapVue from "bootstrap-vue";
import moment from 'moment';

Vue.config.productionTip = false;

Axios.defaults.baseURL = appConfig.baseAPIURL;

const $eventBus = new Vue();
window.addEventListener('message', e => {
  const type = e.data?.type;
  const data = e.data?.data;
  $eventBus.$emit('message', e);
  if(type){
    $eventBus.$emit('message-' + type, data);
  }
})

Vue.prototype.$http = Axios;
Vue.prototype.$eventBus = $eventBus; // Global Event Bus
const APIToken = window.location.href.includes('/partsbridge/activate') || localStorage.getItem("token") ? localStorage.getItem("token")  :  '';
if (APIToken) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = APIToken;
  Vue.prototype.$http.defaults.headers.common["CompanyTimeOffset"] = '0';
}
Vue.prototype.$http.defaults.headers.common["LocalTimeOffset"] = moment().utcOffset()/60;


Vue.use(BootstrapVue);

window.NProgress = require('nprogress');


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

